import { useIntl } from "react-intl";
import { MenuItem } from "./MenuItem";
import { MenuInnerWithSub } from "./MenuInnerWithSub";
import { MegaMenu } from "./MegaMenu";
import { useAuth } from "../../../../../app/modules/auth";
import { useLocation } from "react-router-dom";
import { MenuInnerWithPrimaryMenu } from "./MenuInnerWithPrimaryMenu";
import { usePermissionValues } from "../../../../../app/commonComponents/useCheckPermission";
import { MegaDash } from "./MegaDash";
import { MegaAudioDash } from "./MegaAudioDash";
import { MegaManage } from "./MegaManage";
import { MegaDashAnalytics } from "./MegaDashAnalytics";

export function MenuInner() {
  const intl = useIntl();

  const location = useLocation();

  const { currentUser } = useAuth();

  const customerType = sessionStorage.getItem("CUSTOMER_CONTENT_TYPE");
  const CMS_PRODUCT_NAME = process.env.REACT_APP_CMS_PRODUCT_NAME;
  const isShortApp = sessionStorage.getItem("isShortApp") === "true";

  // console.log("CustomerType::", customerType)

  const {
    permissionVideos, permissionSeries, permissionLiveTV, permissionLibrary, permissionEncoding, permissionVideoLayout,
    permissionAlbums, permissionPodcasts, permissionPlayist, permissionAudioGenres, permissionAudioLayout, permissionEPG, permissionLiveStream,
    permissionCategories, permissionLanguage, permissionGenres, permissionProdHouse, permissionCasts, permissionGeoRestriction, permissionContentPartner, 
    permissionSpecialTag,  permissionCBFC, permissionEpisodeType, permissionOTTGuide, permissionLabel,
    permissionAdminUsers, permissionRoles, permissionBroadcastGroups, permissionBroadcastMessages, permissionFeedbacks,
    permissionContentAnalystics, permissionCustomerAnalystics, 
    permissionDeviceAnalystics, permissionGeoLocationAnalystics, permissionRealTimeAnalystics, permissionAppLauncher, 
    permissionRevenueAnalystics, permissionContentPartnerAnalystics, permissionMonitorAnalystics, permissionAdAnalystics, 
    permissionReportAnalytics, permissionB2BAnalystics,
    permissionPlans, permissionTransaction, permissionAds, permissionSubscription, permissionAdCampaign, permissionPopupContents,
    permissionRental, permissionPaymentGateway, permissionCoupon, permissionReferral, permissionPlanGroups, permissionCoinsHistory, permissionCoinsTransactions,
    permissionMonetizationProfile, permissionAdProfile, permissionRevenuePartner, permissionWalletHistory, permissionRevenuePartnerSubscription,
    permissionStorageSettings, permissionDashboard, permissionGeoFencing, permissionEPGLibrary, permissionActivityTracker, permissionAdSettings,
    permissionUserManagement, permissionSocialLinks, permissionImageConfig, permissionContentUpNext,
    permissionStaticWebPages, permissionEmailTemplate, permissionSMSTemplate, permissionDevicePlaybackConfig
    } = usePermissionValues();

  const permission_Content_Settings = permissionCategories.isViewable || permissionLanguage.isViewable || permissionGenres.isViewable ||
                                      permissionProdHouse.isViewable || permissionCasts.isViewable || permissionGeoRestriction.isViewable ||
                                      permissionSpecialTag.isViewable || permissionCBFC.isViewable ||permissionEpisodeType.isViewable || 
                                      permissionOTTGuide.isViewable || permissionLabel.isViewable;

  const permission_Admin = permissionAdminUsers.isViewable || permissionRoles.isViewable;

  const permission_Broadcast = permissionBroadcastGroups.isViewable || permissionBroadcastMessages.isViewable;

  const permission_Accounts =  permissionUserManagement.isViewable || permissionAdminUsers.isViewable || 
  permissionContentPartner.isViewable || permissionRoles.isViewable;

  const permission_App_Settings = permissionSocialLinks.isViewable || permissionGeoFencing.isViewable || permissionDevicePlaybackConfig.isViewable ||
                                  permissionAdSettings.isViewable;
	const permission_Manage_Temp = permissionStaticWebPages.isViewable || permissionEmailTemplate.isViewable || permissionSMSTemplate.isViewable;


  const Permission_Analytics =  permissionContentAnalystics.isViewable || permissionCustomerAnalystics.isViewable || 
                                permissionDeviceAnalystics.isViewable || permissionGeoLocationAnalystics.isViewable || 
                                permissionRealTimeAnalystics.isViewable || permissionRevenueAnalystics.isViewable || 
                                permissionContentPartnerAnalystics.isViewable || permissionMonitorAnalystics.isViewable || 
                                permissionAdAnalystics.isViewable || permissionReportAnalytics.isViewable ||
                                ((permissionB2BAnalystics.isViewable) && (CMS_PRODUCT_NAME === "INNORELAY" || CMS_PRODUCT_NAME === "ETV"))

  // console.log("contentSettings permission:", permission_Admin);

  const getWidth = () => {
    let count = 0;

    if (permission_Accounts) count++;
    if (permission_App_Settings || permission_Broadcast) count++;
    if (permissionStorageSettings.isViewable || permissionEPGLibrary.isViewable || permissionFeedbacks.isViewable) count++;

    if (count === 3) return "500px";
    if (count === 2) return "300px";
    if (count === 1) return "150px";

    return "";
};


  return (
    <>
      {currentUser?.userType === 'REFERRAL_PARTNER' ? (
        <MenuInnerWithSub
          title="Monetization"
          to="/monetization"
          menuPlacement="bottom-start"
          menuTrigger={`{default:'click', lg: 'hover'}`}
          isMega={false}
          manageWidth={""}
        >
          <MenuItem
            title="Referral Partner"
            to={`/monetization/referral-partner/view/${currentUser?.referralPartnerId}`}
            fontIcon="bi bi-r-square"
          />
        </MenuInnerWithSub>
      ) : (
      <>
      {(location.pathname === "/dashboard" ||
        location.pathname !== "/customers/list") && (
        <>
          {(permissionDashboard.isViewable || currentUser?.userType === 'REVENUE_PARTNER') && (
            <MenuItem
              title={intl.formatMessage({ id: "MENU.DASHBOARD" })}
              to="/dashboard"
            />
          )}
          {(permissionVideos.isViewable ||
            permissionSeries.isViewable ||
            permissionLiveTV.isViewable ||
            permissionLibrary.isViewable ||
            permissionVideoLayout.isViewable ||
            permissionEncoding.isViewable ||
            permissionEPG.isViewable ||
            permissionLiveStream.isViewable
          ) && (customerType === "VOD") && (
            <MenuInnerWithSub
              title="Media"
              to="/content"
              menuPlacement="bottom-start"
              menuTrigger={`{default:'click', lg: 'hover'}`}
              isMega= {true}
              manageWidth={""}
            >
              <MegaDash 
              title="Video"
              to="/content"
              menuPlacement="bottom-start"
              menuTrigger={`{default:'click', lg: 'hover'}`}
              />
            </MenuInnerWithSub>
          )}
          {(permissionAlbums.isViewable ||
            permissionPodcasts.isViewable ||
            permissionPlayist.isViewable ||
            permissionAudioGenres.isViewable ||
            permissionAudioLayout.isViewable) && (customerType === "AOD") && (
            <MenuInnerWithSub
              title="Audio"
              to="/audio"
              menuPlacement="bottom-start"
              menuTrigger={`{default:'click', lg: 'hover'}`}
              isMega= {true}
              manageWidth={""}
            >
              <MegaAudioDash />
            </MenuInnerWithSub>
          )}
          {(permission_Content_Settings) && (
            <MenuInnerWithSub
              title="Content Settings"
              to="/setting-contents"
              menuPlacement="bottom-start"
              menuTrigger={`{default:'click', lg: 'hover'}`}
              isMega= {false}
              manageWidth={""}
            >
            {permissionGenres.isViewable &&
              <MenuItem
                title="Genre"
                to="/setting-contents/genre"
                fontIcon="bi bi-layers-fill"
              />}

            {permissionCasts.isViewable &&
              <MenuItem
                title="Cast"
                to="/setting-contents/cast"
                fontIcon="bi bi-people-fill"
              />}
            {permissionProdHouse.isViewable &&
              <MenuItem
              title="Production House"
              to="/setting-contents/production-company"
              fontIcon="bi bi-film"
              />}
            {permissionLanguage.isViewable &&
              <MenuItem
              title="Language"
              to="/setting-contents/language"
              fontIcon="bi bi-mic-fill"
              />}
            {permissionCategories.isViewable &&
              <MenuItem
              title="Category"
              to="setting-contents/category"
              fontIcon="bi bi-database-fill"
              />}
            {permissionSpecialTag.isViewable &&
              <MenuItem
              title="Special Tag"
              to="setting-contents/special-tag"
              fontIcon="bi bi-bookmark-star-fill"
              />}            
            {permissionLabel.isViewable &&
              <MenuItem
              title="Label"
              to="setting-contents/label"
              fontIcon="bi bi-bookmark-star-fill"
              />}                          
              {permissionCBFC.isViewable &&
              <MenuItem
              title="Age Rating"
              to="setting-contents/age-rating"
              fontIcon="bi bi-camera-reels-fill"
              />}            
              {permissionEpisodeType.isViewable &&
              <MenuItem
              title="Episode Type"
              to="setting-contents/episode-type"
              fontIcon="bi bi-diagram-2-fill"
              />}              
              {permissionOTTGuide.isViewable &&
              <MenuItem
              title="OTT Guidelines"
              to="setting-contents/ott-guide"
              fontIcon="bi bi-collection-play-fill"
              />}                            
            {permissionGeoRestriction.isViewable &&
            <MenuItem
                title="Geo Profiles"
                to="/setting-contents/geo-profiles"
                fontIcon="bi bi-globe-americas"
              />
              }
            </MenuInnerWithSub>
          )}          
          {(Permission_Analytics) && (
            <MenuInnerWithSub
              title="Analytics"
              to="/analytics"
              menuPlacement="bottom-start"
              menuTrigger={`{default:'click', lg: 'hover'}`}
              isMega= {true}
              manageWidth={""}
            >
              <MegaDashAnalytics 
              title="Analytics"
              to="/content"
              menuPlacement="bottom-start"
              menuTrigger={`{default:'click', lg: 'hover'}`}
              />              
            {/* {permissionContentAnalystics.isViewable && (customerType === "VOD") &&
              <MenuItem
                title="Content Analytics"
                to="/analytics/analytics-content"
                fontIcon="bi bi-bar-chart-fill"
              />}

            {permissionAudioAlbumAnalystics.isViewable && (customerType === "AOD") &&
              <MenuItem
                title="Album Analytics"
                to="/analytics/analytics-audio-album"
                fontIcon="bi bi-music-note-list"
              />}
            {permissionAudioTrackAnalystics.isViewable && (customerType === "AOD") &&
              <MenuItem
                title="Track Analytics"
                to="/analytics/analytics-audio-track"
                fontIcon="bi bi-file-music-fill"
              />}
            {permissionAudioPlaylistAnalystics.isViewable && (customerType === "AOD") &&
              <MenuItem
                title="Playlist Analytics"
                to="/analytics/analytics-audio-playlist"
                fontIcon="bi bi-file-earmark-play-fill"
              />}
            {permissionCustomerAnalystics.isViewable &&
              <MenuItem
                title="Customer Analytics"
                to="/analytics/audience"
                fontIcon="bi bi-person-lines-fill"
              />}
            {permissionContentPartnerAnalystics.isViewable &&
            <MenuItem
                title="Content Partner"
                to="/analytics/partner"
                fontIcon="bi bi-fast-forward-btn-fill"
              />
              }
            {permissionDeviceAnalystics.isViewable && (customerType === "VOD") &&
              <MenuItem
                title="Devices"
                to="/analytics/analytics-devices"
                fontIcon="bi bi-pc-display"
              />
            }
           {permissionGeoLocationAnalystics.isViewable &&
              <MenuItem
                title="Geo Location"
                to="/analytics/analytics-geolocation"
                fontIcon="bi bi-pin-map-fill"
              />
            }
           {permissionRealTimeAnalystics.isViewable &&
              <MenuItem
                title="Real time"
                to="/analytics/analytics-realtime"
                fontIcon="bi bi-stopwatch-fill"
              />
            }
            {permissionRevenueAnalystics.isViewable &&
              <MenuItem
                title="Revenue"
                to="/analytics/analytics-revenue"
                fontIcon="bi bi-cash stack"
              />
            }
            {permissionMonitorAnalystics.isViewable &&
              <MenuItem
                title="Grafana Dashboard"
                to="/analytics/analytics-monitor"
                fontIcon="bi bi-pie-chart-fill"
              />
            }
            {permissionReports.isViewable &&
              <MenuItem
                title="Reports Module"
                to="/analytics/reports"
                fontIcon="bi bi-person-lines-fill"
              />
            } */}
            </MenuInnerWithSub>
          )}
          {(permissionPlans.isViewable || permissionTransaction.isViewable || permissionAds.isViewable || permissionRevenuePartner.isViewable ||
          permissionSubscription.isViewable || permissionRental.isViewable || permissionPlanGroups.isViewable || permissionMonetizationProfile.isViewable ||
           permissionPaymentGateway.isViewable || permissionCoupon.isViewable || permissionReferral.isViewable || 
           permissionAdProfile.isViewable || permissionCoinsHistory.isViewable || permissionCoinsTransactions.isViewable) && (
            <MenuInnerWithSub
              title="Monetization"
              to="/monetization"
              menuPlacement="bottom-start"
              menuTrigger={`{default:'click', lg: 'hover'}`}
              isMega= {false}
              manageWidth={"500px"}
            >
            {permissionPlans.isViewable &&
              <MenuItem
                title="Plans"
                to="/monetization/plans"
                fontIcon="bi bi-card-list"
                onClick={() => {
                  if (location.pathname.includes('/monetization/plans')) {
                    return
                  }

                  sessionStorage.removeItem('plans_search_value')
                  sessionStorage.removeItem('plans_pagination')
                }}
              />}
            {permissionPlanGroups.isViewable &&
              <MenuItem
                title="Plan Groups"
                to="/monetization/plan-groups"
                fontIcon="bi bi-diagram-3"
              />}              
            {permissionMonetizationProfile.isViewable &&
              <MenuItem
                title="Monetization Profiles"
                to="/monetization/profiles"
                fontIcon="bi bi-person-lines-fill"
              />}  
            {permissionAdProfile.isViewable &&
              <MenuItem
                title="Ad Profiles"
                to="/monetization/ads-profile"
                fontIcon="bi bi-clipboard2-data"
              />}             
            {permissionTransaction.isViewable &&
              <MenuItem
                title="Transactions"
                to="/monetization/transaction"
                fontIcon="bi bi-credit-card"
              />}    
            {(permissionSubscription.isViewable && CMS_PRODUCT_NAME !== "ETV") &&
              <MenuItem
                title="Subscription"
                to="/monetization/subscription"
                fontIcon="bi bi-cash-stack"
              />}
            {permissionRental.isViewable &&
              <MenuItem
                title="Rental"
                to="/monetization/rental"
                fontIcon="bi bi-calendar3"
              />}
            {(permissionCoinsHistory.isViewable && isShortApp) &&
              <MenuItem
                title="Coin History"
                to="/monetization/coins-history"
                fontIcon="bi bi-database"
              />}
            {(permissionCoinsTransactions.isViewable && isShortApp) &&
              <MenuItem
                title="Coin Transactions"
                to="/monetization/coins-transactions"
                fontIcon="bi bi-database"
              />}
            {permissionPaymentGateway.isViewable &&
              <MenuItem
                title="Payment Gateways"
                to="/monetization/payment-gateways"
                fontIcon="bi bi-currency-dollar"
              />}
           {permissionCoupon.isViewable &&
              <MenuItem
                title="Coupons"
                to="/monetization/coupons"
                fontIcon="bi bi-ticket-detailed"
              />}
           {permissionReferral.isViewable &&
              <MenuItem
                title="Referral Partner"
                to="/monetization/referral-partner"
                fontIcon="bi bi-r-square"
              />}              
            {permissionRevenuePartner.isViewable &&
              <MenuItem
                title="Revenue Partner"
                to="/monetization/revenue-partner"
                fontIcon="bi bi-bank"
              />}   
            {permissionRevenuePartnerSubscription.isViewable &&
              <MenuItem
                title="Revenue Partner History"
                to="/monetization/revenue-subscription"
                fontIcon="bi bi-credit-card-2-back"
              />}              
            {permissionWalletHistory.isViewable &&
              <MenuItem
                title="Revenue Partner Wallet History"
                to="/monetization/wallet-history"
                fontIcon="bi bi-wallet pb-3"
              />}              
            </MenuInnerWithSub>
          )}
          {(permissionAds.isViewable || permissionAdCampaign.isViewable || 
          permissionAppLauncher.isViewable || permissionPopupContents.isViewable ||
          permissionContentUpNext.isViewable) && (
            <MenuInnerWithSub
              title="Advertisement"
              to="/advertisement"
              menuPlacement="bottom-start"
              menuTrigger={`{default:'click', lg: 'hover'}`}
              isMega= {false}
              manageWidth={""}
            >
            {permissionAds.isViewable &&
              <MenuItem
                title="Manage Ads"
                to="/advertisement/ads"
                fontIcon="bi bi-badge-ad"
              />}     
            {permissionAdCampaign.isViewable &&
              <MenuItem
                title="Ad Campaign"
                to="/advertisement/ad-campaign"
                fontIcon="bi bi-clipboard2-data"
              />}  
              {permissionAppLauncher.isViewable &&
              <MenuItem
                title="Ad Popup"
                to="/advertisement/app-launcher"
                fontIcon="bi bi-layers"
              />}           
              {permissionPopupContents.isViewable &&
              <MenuItem
                title="Profile List Ads"
                to="/advertisement/profile-ad"
                fontIcon="bi bi-file-arrow-up"
              />}
              {permissionContentUpNext.isViewable &&
              <MenuItem
                title="Content Upnext Rule"
                to="/advertisement/cont-upnext"
                fontIcon="bi bi-card-list"
              />}                                             
            </MenuInnerWithSub>
          )}
          {(permission_Accounts ||
            permission_App_Settings ||
            permission_Manage_Temp ||
            permission_Broadcast ||
            permissionStorageSettings.isViewable || 
            permissionFeedbacks.isViewable) && (
            <MenuInnerWithSub
              title="Manage"
              to="/manage"
              menuPlacement="bottom-end"
              menuTrigger={`{default:'click', lg: 'hover'}`}
              isMega= {true}
              isManage={true}
              manageWidth= {getWidth()}
            >
              <MegaManage 
              title="Manage"
              to="/manage"
              menuPlacement="bottom-end"
              menuTrigger={`{default:'click', lg: 'hover'}`}
              />
            </MenuInnerWithSub>   )}   

          {(currentUser?.userType === 'REVENUE_PARTNER') && (
            <MenuItem
              title="User Accounts"
              to="/revenue-partner/users"
            />
          )}

          {(currentUser?.userType === 'REVENUE_PARTNER') && (
            <MenuItem
              title="Subscription History"
              to="/revenue-partner/recharge-history"
            />
          )}

          {(currentUser?.userType === 'REVENUE_PARTNER') && (
            <MenuItem
              title="My Wallet"
              to="/revenue-partner/my-wallet"
            />
          )}

          {/* {(permission_Content_Settings ||
            permission_Admin ||
            permission_Broadcast ||
            permissionStorageSettings.isViewable || 
            permissionUserManagement.isViewable ||
            permissionFeedbacks.isViewable ||
            permissionGeoFencing.isViewable) && (
            <MenuInnerWithSub
              title="Manage"
              to="/manage"
              menuPlacement="bottom-start"
              menuTrigger={`{default:'click', lg: 'hover'}`}
              isMega= {false}
            >
              {permission_Admin && 
              <MenuInnerWithSub
                title="Accounts"
                to="/manage/usermanagement"
                fontIcon="bi-person-fill-gear"
                hasArrow={true}
                menuPlacement="right-start"
                menuTrigger={`{default:'click', lg: 'hover'}`}
              >
            {permissionUserManagement.isViewable &&
                <MenuItem
                to="/manage/accounts/users"
                  title="Customers"
                  hasBullet={true}
                />}                
            {permissionAdminUsers.isViewable &&
                <MenuItem
                  to="/manage/accounts/admins"
                  title="Admins"
                  hasBullet={true}
                />}
            {permissionGeoRestriction.isViewable &&
                <MenuItem
                to="/manage/accounts/cont-partner"
                title="Content Partner"
                hasBullet={true}
                />}    
            {permissionRoles.isViewable &&
                <MenuItem
                  to="/manage/accounts/roles"
                  title="Roles"
                  hasBullet={true}
                />}
              </MenuInnerWithSub>}

              {(currentUser?.userType === "SUPERADMIN") &&
              <MenuInnerWithSub
                title="Integrations"
                to="/settings"
                fontIcon="bi-gear-wide-connected"
                hasArrow={true}
                menuPlacement="right-start"
                menuTrigger={`{default:'click', lg: 'hover'}`}
              >
                <MenuItem
                  to="/settings/email-config"
                  title="Email Config"
                  hasBullet={true}
                />                
                <MenuItem
                  to="/settings/tmdb"
                  title="TMDB"
                  hasBullet={true}
                />
                <MenuItem
                  to="/settings/firebase"
                  title="Firebase"
                  hasBullet={true}
                />
                <MenuItem
                to="/manage/integration/storage"
                title="Storage"
                hasBullet={true}
                />
              </MenuInnerWithSub>}

             {(permissionSocialLinks.isViewable || permissionImageConfig.isViewable) && 
              <MenuInnerWithSub
                title="App Settings"
                to="/page-settings"
                fontIcon="bi-gear-fill"
                hasArrow={true}
                menuPlacement="right-start"
                menuTrigger={`{default:'click', lg: 'hover'}`}
              >
              {(permissionSocialLinks.isViewable) && 
                <MenuItem
                  to="/page-settings/social-links"
                  title="Social Links"
                  hasBullet={true}
                />}
              {(permissionImageConfig.isViewable) && 
                <MenuItem
                  to="/page-settings/image-config/login"
                  title="Image Config"
                  hasBullet={true}
                />}
              {permissionGeoFencing.isViewable &&
                <MenuItem
                to="/manage/geofencing"
                title="Geo Fencing"
                  hasBullet={true}
                />}                
              </MenuInnerWithSub>}              

              {permission_Broadcast && 
              <MenuInnerWithSub
                title="Notification"
                to="/manage/notification"
                fontIcon="bi-layers"
                hasArrow={true}
                menuPlacement="right-start"
                menuTrigger={`{default:'click', lg: 'hover'}`}
              >
            {permissionBroadcastGroups.isViewable &&
                <MenuItem
                  to="/manage/notification/groups"
                  title="Groups"
                  hasBullet={true}
                />}
            {permissionBroadcastMessages.isViewable &&
                <MenuItem
                  to="/manage/notification/broadcast"
                  title="Messages"
                  hasBullet={true}
                />}
              </MenuInnerWithSub>}

              {permissionFeedbacks.isViewable && 
              <MenuInnerWithSub
                title="Help & Support"
                to="/manage/notification"
                fontIcon="bi-layers"
                hasArrow={true}
                menuPlacement="right-start"
                menuTrigger={`{default:'click', lg: 'hover'}`}
              >
              {permissionFeedbacks.isViewable &&
                <MenuItem
                to="/manage/accounts/feedbacks"
                  title="Feedbacks"
                  hasBullet={true}
                />}
              </MenuInnerWithSub>} */}



                         {/* {permissionFeedbacks.isViewable &&
              <MenuItem
                title="Feedbacks"
                to="/manage/accounts/feedbacks"
                fontIcon="bi-ticket"
              />}  */}

 



              {/* STORAGE SETTINGS */}
              {/* {permissionStorageSettings.isViewable &&
              <MenuItem
                title="Storage Settings"
                to="/manage/integration/storage"
                fontIcon="bi-folder"
              />
              } */}

              {/* USER MANAGEMENT */}
              {/* {permissionUserManagement.isViewable &&
              <MenuItem
                title="Customers"
                to="/manage/accounts/users"
                fontIcon="bi-person"
              />} */}
              {/* Feedback */}

              {/* GEO Fencing */}


            {/* </MenuInnerWithSub>
          )} */}

          {/* {(currentUser?.userType === "SUPERADMIN" ||
            permissionGeoFencing.isViewable) && (
            <MenuInnerWithSub
              title="Settings"
              to="/settings"
              menuPlacement="bottom-start"
              menuTrigger={`{default:'click', lg: 'hover'}`}
              isMega= {false}
            >
          
              <MenuItem
                title="Integration"
                to="/settings/firebase"
                fontIcon="bi bi-intersect"
              />
             
            </MenuInnerWithSub>
          )} */}

          
        </>
      )}
      {/* {(permissionVideos.isViewable || permissionSeries.isViewable || permissionLiveTV.isViewable ||
            permissionLibrary || permissionVideoLayout || permissionEncoding.isViewable) && ( 
          <MenuItem
            title={intl.formatMessage({ id: "MENU.VIDEOS" })}
            to="/content"
          />)} */}
      {/* {(permissionAlbums.isViewable || permissionPodcasts.isViewable || 
            permissionPlayist.isViewable || permissionAudioGenres.isViewable || permissionAudioLayout.isViewable) && (
          <MenuItem
            title={intl.formatMessage({ id: "MENU.AUDIOS" })}
            to="/audio"
          />)} */}
      {/* {(permissionCustomerAnalystics.isViewable || permissionContentAnalystics.isViewable || permissionAudioAnalystics.isViewable) && (
          <MenuItem
            title={intl.formatMessage({ id: "MENU.ANALYTICS" })}
            to="/analytics"
          />)} */}
      {/* {(permissionPlans.isViewable || permissionTransaction.isViewable) && (
           <MenuItem
            title={intl.formatMessage({ id: "MENU.MONETIZATION" })}
            to="/monetization"
          />)} */}
      {/* {(permission_Content_Settings || permission_Admin || permission_Broadcast || 
            permissionUserManagement.isViewable || permissionFeedbacks.isViewable) &&  (
          <MenuItem
            title={intl.formatMessage({ id: "MENU.MANAGE" })}
            to="/manage"
          />
          )} */}
      {/* {((currentUser?.userType === 'SUPERADMIN') || (permissionGeoFencing.isViewable)) && 
          <MenuItem
            title={'Settings'}
            to="/settings"
          />
          } */}
      {/* {(location.pathname === "/content" || 
        (location.pathname.includes("/content") )) && (
        <>
          <MenuInnerWithPrimaryMenu
            title="Content"
            to="/content"
            menuPlacement="bottom-start"
            menuTrigger={`{default:'click', lg: 'hover'}`}
          >
            {(permissionVideos.isViewable) && (
            <MenuItem to="/content/video" title="Video" /> )}
            {(permissionSeries.isViewable) && (
            <MenuItem to="/content/playlist" title="Series" /> )}
            {(permissionLiveTV.isViewable) && (
            <MenuItem to="/content/livetv" title="Live TV" />)}
            {(permissionLibrary.isViewable) && (
            <MenuItem to="/content/library" title="Library" />)}
            {(permissionEncoding.isViewable) && (
            <MenuItem to="/content/encoding" title="Encoding" />)}
            {(permissionVideoLayout.isViewable) && (
            <MenuItem to="/content/layout/general-layout" title="Layout" />)} 
            {/* <MenuItem
              title={intl.formatMessage({ id: "MENU.MONETIZATION" })}
              to="content/monetization"
            /> 
          </MenuInnerWithPrimaryMenu>
        </>
      )} */}
      {/* {(location.pathname === "/audio" ||
        location.pathname.includes("/audio")) && (
        <>
          <MenuInnerWithPrimaryMenu
            title="Audio"
            to="/audio"
            menuPlacement="bottom-start"
            menuTrigger={`{default:'click', lg: 'hover'}`}
          >
            {(permissionAlbums.isViewable) && (
            <MenuItem to="/audio/albums" title="Albums" />)}
            {(permissionPodcasts.isViewable) && (
            <MenuItem to="/audio/podcast" title="Podcast" />)}
            {(permissionPlayist.isViewable) && (
            <MenuItem to="/audio/playlist" title="Playlist" />)}
            {(permissionAudioGenres.isViewable) && (
            <MenuItem to="/audio/genre" title="Genre" />)}
            {(permissionAudioLayout.isViewable) && (
            <MenuItem to="/audio/layout" title="Layout" /> )}
          </MenuInnerWithPrimaryMenu>
        </>
      )} */}
      {/* {(location.pathname === "/manage" ||
        location.pathname.includes("/manage")) && (
        <>
          <MenuInnerWithPrimaryMenu
            title="Manage"
            to="/manage"
            menuPlacement="bottom-start"
            menuTrigger={`{default:'click', lg: 'hover'}`}
          >
            {(permissionCategories.isViewable || permissionLanguage.isViewable || permissionGenres.isViewable ||
            permissionProdHouse.isViewable || permissionCasts.isViewable || permissionGeoRestriction.isViewable ||
            permissionContentPartner.isViewable) &&  (
            <MenuItem to="/setting-contents" title="Content Settings" />)}
            {(permissionUserManagement.isViewable) && (
            <MenuItem to="/manage/accounts/users" title="User Management" />)}
            {(permissionAdminUsers.isViewable || permissionRoles.isViewable ) && (
            <MenuItem to="/manage/usermanagement" title="Admins" />)}
            {(permissionBroadcastGroups.isViewable || permissionBroadcastMessages.isViewable) && (
            <MenuItem to="/manage/notification" title="Broadcast" />)}
            {(permissionFeedbacks.isViewable) && (
            <MenuItem to="/manage/accounts/feedbacks" title="Feedback" />)}


            {/* <MenuItem to="/manage/production-company" title="Production House" />
            <MenuItem to="/manage/accounts/users" title="Customers" />
            <MenuItem to="/manage/usermanagement" title="Admins" />
            <MenuItem to="/manage/layout" title="Layout" /> 
            <MenuItem to="/manage/notification" title="Notification" /> 
          </MenuInnerWithPrimaryMenu>
        </>
      )} */}
      {/* {(location.pathname === "/settings" ||
        location.pathname.includes("/settings")) && (
        <>
          <MenuInnerWithPrimaryMenu
            title="Settings"
            to="/settings"
            menuPlacement="bottom-start"
            menuTrigger={`{default:'click', lg: 'hover'}`}
          >
           {currentUser?.userType === 'SUPERADMIN' && 
             <MenuItem to="/settings/firebase" title="Integration" />}
           {(permissionGeoFencing.isViewable) && (
             <MenuItem to="/manage/geofencing" title="Geo Fencing"/>)}
             {/* <MenuItem to="/settings/profile-settings/user" title="Profile Settings"/> */}
      {/* <MenuItem to="/settings/customerconfig" title="Customer Config" />
            <MenuItem to="/settings/payment" title="Payment" /> 
          </MenuInnerWithPrimaryMenu>
        </>
      )} */}

      {/* <MenuInnerWithSub
        title={intl.formatMessage({ id: "MENU.CONTENT_MANAGEMENT" })}
        to="/analytics"
        menuPlacement="bottom-start"
        menuTrigger={`{default:'click', lg: 'hover'}`}
      >
        <MenuItem
          to="/analytics/user-analytics"
          title={intl.formatMessage({ id: "MENU.CONTENT_MANAGEMENT.VIDEOS" })}
          hasBullet={true}
        />
        <MenuItem
          to="/analytics/content-analytics"
          title={intl.formatMessage({ id: "MENU.CONTENT_MANAGEMENT.SERIES" })}
          hasBullet={true}
        />
        <MenuItem
          to="/analytics/content-analytics"
          title={intl.formatMessage({ id: "MENU.CONTENT_MANAGEMENT.LAYOUTS" })}
          hasBullet={true}
        />
      </MenuInnerWithSub>
      <MenuInnerWithSub
        title={intl.formatMessage({ id: "MENU.CONTENT_LIBRARY" })}
        to="/content-library"
        menuPlacement="bottom-start"
        menuTrigger={`{default:'click', lg: 'hover'}`}
      >
        <MenuItem
          to="/content-library/video-library"
          title={intl.formatMessage({
            id: "MENU.CONTENT_LIBRARY.VIDEO_LIBRARY",
          })}
          hasBullet={true}
        />
        <MenuItem
          to="/content-library/audio-library"
          title={intl.formatMessage({
            id: "MENU.CONTENT_LIBRARY.AUDIO_LIBRARY",
          })}
          hasBullet={true}
        />
      </MenuInnerWithSub>  */}
      {/* <MenuInnerWithSub
        title={intl.formatMessage({ id: "MENU.CONTENT_SETTINGS" })}
        to="/content-settings"
        menuPlacement="bottom-start"
        menuTrigger={`{default:'click', lg: 'hover'}`}
      >
        <MenuItem
          to="/content-settings/genre"
          title={intl.formatMessage({ id: "MENU.CONTENT_SETTINGS.GENRE" })}
          hasBullet={true}
        />
        <MenuItem
          to="/content-settings/languages"
          title={intl.formatMessage({ id: "MENU.CONTENT_SETTINGS.LANGUAGES" })}
          hasBullet={true}
        />
        <MenuItem
          to="/content-settings/cast"
          title={intl.formatMessage({ id: "MENU.CONTENT_SETTINGS.CAST" })}
          hasBullet={true}
        />
        <MenuItem
          to="/content-settings/category"
          title={intl.formatMessage({ id: "MENU.CONTENT_SETTINGS.CATEGORY" })}
          hasBullet={true}
        />
      </MenuInnerWithSub>
      <MenuInnerWithSub
        title={intl.formatMessage({ id: "MENU.MONETIZATION" })}
        to="/monetization"
        menuPlacement="bottom-start"
        menuTrigger={`{default:'click', lg: 'hover'}`}
      >
        <MenuItem
          to="/monetization/subscription"
          title={intl.formatMessage({
            id: "MENU.MONETIZATION.SUBSCRIPTION",
          })}
          hasBullet={true}
        />
        <MenuItem
          to="/monetization/transactions"
          title={intl.formatMessage({
            id: "MENU.MONETIZATION.TRANSACTIONS",
          })}
          hasBullet={true}
        />
      </MenuInnerWithSub>
      <MenuInnerWithSub
        title={intl.formatMessage({ id: "MENU.NOTIFICATIONS" })}
        to="/notifications"
        menuPlacement="bottom-start"
        menuTrigger={`{default:'click', lg: 'hover'}`}
      >
        <MenuItem
          to="/notifications/app-version"
          title={intl.formatMessage({
            id: "MENU.NOTIFICATIONS.APP_VERSION",
          })}
          hasBullet={true}
        />
        <MenuItem
          to="/notifications/notification-groups"
          title={intl.formatMessage({
            id: "MENU.NOTIFICATIONS.NOTIFICATION_GROUPS",
          })}
          hasBullet={true}
        />
        <MenuItem
          to="/notifications/notifications"
          title={intl.formatMessage({
            id: "MENU.NOTIFICATIONS.NOTIFICATIONS",
          })}
          hasBullet={true}
        />
      </MenuInnerWithSub>
      <MenuInnerWithSub
        title={intl.formatMessage({ id: "MENU.SUPPORT" })}
        to="/support"
        menuPlacement="bottom-start"
        menuTrigger={`{default:'click', lg: 'hover'}`}
      >
        <MenuItem
          to="/support/tickets"
          title={intl.formatMessage({
            id: "MENU.SUPPORT.TICKETS",
          })}
          hasBullet={true}
        />
      </MenuInnerWithSub>
      <MenuInnerWithSub
        title={intl.formatMessage({ id: "MENU.ADMIN" })}
        to="/admin"
        menuPlacement="bottom-start"
        menuTrigger={`{default:'click', lg: 'hover'}`}
      >
        <MenuItem
          to="/admin/admin-users"
          title={intl.formatMessage({
            id: "MENU.ADMIN.ADMIN_USERS",
          })}
          hasBullet={true}
        />
        <MenuItem
          to="/admin/roles"
          title={intl.formatMessage({
            id: "MENU.ADMIN.ROLES",
          })}
          hasBullet={true}
        />
      </MenuInnerWithSub> */}
    </>
    )}
  </>
  );
}
